import Web3 from 'web3';

// 初始化 Web3 实例
const web3 = new Web3();

export function useTokenToUsdt(tokenAmountWei, tokenPriceUsdt) {
  const totalPriceUsdt = (tokenAmountWei * tokenPriceUsdt).toFixed(3);

  return {
    totalPriceUsdt, // USDT 总价格
  };
}